import { useState } from "react";
import { bytesToMegabytes } from "@/lib/utils";
import { t } from "i18next";
import { ALLOWED_AUDIO_EXTENSION, MAX_AUDIO_MB } from "@/common/config";

interface UseAudioValidation {
  error: string | null;
  validateFile: (file: File) => boolean;
  resetError: () => void;
}

export const useAudioValidation = (): UseAudioValidation => {
  const [error, setError] = useState<string | null>(null);
  const validateFile = (file: File): boolean => {
    const sizeMB = bytesToMegabytes(file.size);
    const isValidSize = sizeMB < MAX_AUDIO_MB;
    const isValidType = ALLOWED_AUDIO_EXTENSION.some((type) =>
      file.type.includes(type)
    );
    if (!isValidSize) {
      setError(
        t("error.formRecorder.maximumSize", {
          MAX_AUDIO_MB: MAX_AUDIO_MB.toFixed(1),
        })
      );
      return false;
    }
    if (!isValidType) {
      setError(t("error.formRecorder.unsupportedFormat"));
      return false;
    }
    setError(null);
    return true;
  };

  const resetError = (): void => {
    setError(null);
  };

  return { error, validateFile, resetError };
};
